<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'专业人员26'"  :activeNames="'专业人员'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">专业人员</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Professional</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 专业人员</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:center;width:94%;">专业人员</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;text-align:center;width:94%;">Professional</div>
			<div style="margin-left: 3%;margin-top:10px;width:94%;">
				
				<div style="text-align: center;margin-top: 20px;" class="professionalSelect">
					<div style="width: 23%;float: left;">
						<el-input
							v-model="name"
							placeholder="姓名">
							<i
								class="el-icon-search el-input__icon"
								slot="suffix"
								@click="queryParam()">
							</i>
						</el-input>
					</div>
					<div style="width: 24%;float: left;margin-left: 2%;">
						<el-select v-model="relationship_id" clearable placeholder="职位" @change="queryParam()">
							<el-option
								v-for="item in relationshipList"
								:key="item.id"
								:label="item.label"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="width: 24%;float: left;;margin-left: 2%;margin-right:2%;">
						<el-select v-model="service_id" clearable placeholder="业务领域" @change="queryParam()">
							<el-option
								v-for="item in serviceList"
								:key="item.id"
								:label="item.title"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="width: 23%;float: left;">
						<el-select v-model="address_name" clearable placeholder="地区" @change="queryParam()">
							<el-option
								v-for="item in ['上海','唐山','西安','太原','郑州','海口','重庆','合肥']"
								:key="item"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div style="width: 94%;margin-left: 3%;margin-bottom: 30px;margin-top: 80px;">
				<div v-for="(item,index) in tableList" :key="index" style="margin-top: 25px;height: 200px;margin-bottom: 10px;background-color: #F2F2F2;">
					<div style="float: left;width: 55%;padding-left: 5%;">
							<div @click="toDetail(item)" style="padding-top: 40px;font-size: 18px;cursor: pointer;">{{item.name}}</div>
							<div style="font-size: 12px;margin-top: 5px;color: rgb(153, 153, 153);padding-bottom: 5px;border-bottom: 1px solid rgb(215, 215, 215);width: 50%;">{{item.relationship_name}}</div>
							<div style="padding-top: 10px;font-size: 14px;color: rgb(102, 102, 102);line-height: 22px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">{{item.content}}</div>
						</div>
					<div style="float: left;width: 40%;height: 100%;">
							<img  @click="toDetail(item)" style="height: 100%;width: 100%;" :src="item.image">
						</div>
				</div>
			</div>
			
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="4"
				:total="total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {queryTreeChannelByPid} from '@/api/channel'
	import {queryService} from "@/api/service";
	import {query} from "@/api/lawyer";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				
				tableList: [],
				total:0,
				pageNo: 1,
				name:'',
				relationship_id:null,
				relationshipList:[],
				service_id:null,
				serviceList: [],
				address_name:''
			}
		},
		mounted() {
			this.pageNo = 1;
			this.query()
			this.queryRelationshipList()
			this.queryServiceList()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			toDetail(item,index){
				this.$router.push(
					{
						path:'/phoneProfessionalDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			queryRelationshipList(){
				queryTreeChannelByPid(26).then(data => {
					this.relationshipList = data.data
					console.log(this.treeData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			queryServiceList(){
				let param = {
					page: 1,
					pageSize: 99999,
				}
				queryService(param).then(data => {
					this.serviceList = data.data.list
					console.log(this.treeData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.query()
			},
			changeRelationshipId(relationship_id){
				this.relationship_id = relationship_id;
				this.pageNo = 1;
				this.query()
			},
			handleIconClick(){
				console.log('handleIconClick')
			},
			queryParam(){
				this.pageNo = 1;
				this.query()
			},
			query() {
				let param = {
					name: this.name,
					service_id: this.service_id,
					relationship_id: this.relationship_id,
					address_name:this.address_name,
					page: this.pageNo,
					pageSize: 4,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
	margin-bottom: 20px;
}
</style>
